export enum MarkerType {
    ORIGIN = 'origin',
    DESTINATION = 'destination',
    WAYPOINT = 'waypoint'
}

export enum TrafficAlertType {
    ROAD_CLOSURES = 'ROAD_CLOSURES',
    INCIDENTS = 'INCIDENTS',
    ROADWORKS = 'ROADWORKS',
    CONGESTION = 'CONGESTION',
    LANE_CLOSED = 'LANE_CLOSED',
    WEATHER_INCIDENTS = 'WEATHER_INCIDENTS',

    HOTELS_AND_B_B = 'Hotels and B&Bs',
    RESTAURANTS = 'RESTAURANTS',
   // CAR_PARKS = 'Car parks'
}

export enum GoogleMapType {
    ROUTE_PLANNER = 0,
    TRAFFIC_NEWS = 1,
    MAPS = 2,
    ROUTE_PRINT_MAP = 3,
    ROUTE_PRINT_PREVIEW = 4,
}

export enum AAClusterType {
    TRAFFIC_ALERT_CLUSTER = 0,
    CAR_PARK_CLUSTER = 1,
    TRAVEL_CLUSTER = 2
}
